import { render, staticRenderFns } from "./SingleData.vue?vue&type=template&id=768e4774"
import script from "./SingleData.vue?vue&type=script&lang=ts"
export * from "./SingleData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports